var map = {
	"./Vectorillus1": 21,
	"./Vectorillus1.png": 21,
	"./airtel": 22,
	"./airtel-money1": 23,
	"./airtel-money1.png": 23,
	"./airtel.png": 22,
	"./al-izza": 24,
	"./al-izza-grey": 25,
	"./al-izza-grey.png": 25,
	"./al-izza.png": 24,
	"./alizza": 10,
	"./alizza-square": 26,
	"./alizza-square.png": 26,
	"./alizza.jpg": 327,
	"./alizza.png": 10,
	"./amanata": 11,
	"./amanata.jpg": 328,
	"./amanata.png": 11,
	"./amicoboutiq": 27,
	"./amicoboutiq.svg": 27,
	"./ansi": 28,
	"./ansi.png": 28,
	"./auth-hero-payments": 29,
	"./auth-hero-payments.webp": 29,
	"./benin": 30,
	"./benin.png": 30,
	"./bg-cover": 31,
	"./bg-cover.png": 31,
	"./bia-niger": 32,
	"./bia-niger.png": 32,
	"./boa-icon": 33,
	"./boa-icon.png": 33,
	"./checkmark": 34,
	"./checkmark-white": 35,
	"./checkmark-white.svg": 35,
	"./checkmark.svg": 34,
	"./chevron-down": 36,
	"./chevron-down.svg": 36,
	"./chevron-up": 37,
	"./chevron-up.svg": 37,
	"./cip": 12,
	"./cip.jpg": 329,
	"./cip.png": 12,
	"./circle-scatter": 38,
	"./circle-scatter.svg": 38,
	"./contact-receive-payments": 39,
	"./contact-receive-payments.png": 39,
	"./coris-money": 40,
	"./coris-money.png": 40,
	"./default-avatar": 41,
	"./default-avatar.png": 41,
	"./default-image": 42,
	"./default-image.png": 42,
	"./ecobank": 13,
	"./ecobank.jpg": 330,
	"./ecobank.png": 13,
	"./ecobanq": 43,
	"./ecobanq.png": 43,
	"./ecobanqc": 44,
	"./ecobanqc.png": 44,
	"./fa-envelope": 45,
	"./fa-envelope.png": 45,
	"./fa-phone": 46,
	"./fa-phone.png": 46,
	"./facebook": 47,
	"./facebook.png": 47,
	"./flutter": 48,
	"./flutter-white": 49,
	"./flutter-white.png": 49,
	"./flutter.png": 48,
	"./group2": 50,
	"./group2.svg": 50,
	"./grouplink": 51,
	"./grouplink.png": 51,
	"./hero-payments": 52,
	"./hero-payments.png": 52,
	"./ifutur": 53,
	"./ifutur-matrix": 54,
	"./ifutur-matrix.png": 54,
	"./ifutur.png": 53,
	"./ifuturhommefemme": 55,
	"./ifuturhommefemme.png": 55,
	"./image3": 56,
	"./image3.png": 56,
	"./ipaymoney1": 57,
	"./ipaymoney1.svg": 57,
	"./javascript-white": 58,
	"./javascript-white.png": 58,
	"./line": 59,
	"./line.png": 59,
	"./linkedin": 60,
	"./linkedin.png": 60,
	"./logo": 61,
	"./logo-ansi": 62,
	"./logo-ansi.png": 62,
	"./logo-coris-bank": 63,
	"./logo-coris-bank.jpg": 63,
	"./logo-nita": 64,
	"./logo-nita.png": 64,
	"./logo-obn": 65,
	"./logo-obn.png": 65,
	"./logo-white": 66,
	"./logo-white.png": 66,
	"./logo.png": 61,
	"./logo_alizza": 67,
	"./logo_alizza.png": 67,
	"./logoip": 68,
	"./logoip.png": 68,
	"./logoip_blanc": 69,
	"./logoip_blanc.png": 69,
	"./long-page": 70,
	"./long-page.png": 70,
	"./lp-line-separator": 71,
	"./lp-line-separator.png": 71,
	"./lp-phone": 72,
	"./lp-phone.png": 72,
	"./lp-store": 73,
	"./lp-store.png": 73,
	"./lp-tpe": 74,
	"./lp-tpe.png": 74,
	"./map-screenshot": 75,
	"./map-screenshot.png": 75,
	"./mastercard": 14,
	"./mastercard-logo": 76,
	"./mastercard-logo.png": 76,
	"./mastercard.jpg": 331,
	"./mastercard.png": 14,
	"./moov": 77,
	"./moov-money": 78,
	"./moov-money.png": 78,
	"./moov.png": 77,
	"./moovc": 79,
	"./moovc.png": 79,
	"./mtn": 80,
	"./mtn.png": 80,
	"./my_nita": 81,
	"./my_nita.png": 81,
	"./necs": 82,
	"./necs.jpeg": 82,
	"./new-logo": 83,
	"./new-logo.png": 83,
	"./niger": 84,
	"./niger.png": 84,
	"./nita": 85,
	"./nita-square": 86,
	"./nita-square.png": 86,
	"./nita.png": 85,
	"./nita_online_payment_steps/1": 87,
	"./nita_online_payment_steps/1.png": 87,
	"./nita_online_payment_steps/2": 88,
	"./nita_online_payment_steps/2.png": 88,
	"./nita_online_payment_steps/3": 89,
	"./nita_online_payment_steps/3.png": 89,
	"./nita_online_payment_steps/4": 90,
	"./nita_online_payment_steps/4.png": 90,
	"./obeecs": 91,
	"./obeecs.png": 91,
	"./obn": 92,
	"./obn.png": 92,
	"./onecs": 93,
	"./onecs.png": 93,
	"./orabank": 15,
	"./orabank.jpg": 332,
	"./orabank.png": 15,
	"./ordi1": 94,
	"./ordi1.png": 94,
	"./ordi2": 95,
	"./ordi2.png": 95,
	"./oxfam": 96,
	"./oxfam.png": 96,
	"./oxfamc": 97,
	"./oxfamc.png": 97,
	"./partners/africa-development-universalis": 98,
	"./partners/africa-development-universalis.png": 98,
	"./partners/airtel": 99,
	"./partners/airtel-1": 100,
	"./partners/airtel-1.png": 100,
	"./partners/airtel.jpeg": 99,
	"./partners/ansi": 101,
	"./partners/ansi.png": 101,
	"./partners/armoiries": 102,
	"./partners/armoiries.png": 102,
	"./partners/banque-mondiale": 103,
	"./partners/banque-mondiale.png": 103,
	"./partners/boa": 104,
	"./partners/boa.png": 104,
	"./partners/eco-xpress": 105,
	"./partners/eco-xpress.png": 105,
	"./partners/helen-keller-int": 106,
	"./partners/helen-keller-int.png": 106,
	"./partners/moov-africa": 107,
	"./partners/moov-africa.jpeg": 107,
	"./partners/mtn": 108,
	"./partners/mtn.png": 108,
	"./partners/necs": 109,
	"./partners/necs.jpeg": 109,
	"./partners/obn": 110,
	"./partners/obn.png": 110,
	"./partners/onep": 111,
	"./partners/onep.png": 111,
	"./partners/orange": 112,
	"./partners/orange.png": 112,
	"./partners/oxfam": 113,
	"./partners/oxfam.png": 113,
	"./partners/pvi": 114,
	"./partners/pvi.png": 114,
	"./partners/snfi": 115,
	"./partners/snfi.png": 115,
	"./partners/snv": 116,
	"./partners/snv.png": 116,
	"./partners/sunu-assurance": 117,
	"./partners/sunu-assurance.png": 117,
	"./partners/swiss-contact": 118,
	"./partners/swiss-contact.png": 118,
	"./partners/uddm": 119,
	"./partners/uddm.png": 119,
	"./partners/uncdf": 120,
	"./partners/uncdf.png": 120,
	"./partners/universite-agadez": 121,
	"./partners/universite-agadez.png": 121,
	"./partners/world-health-organisation": 122,
	"./partners/world-health-organisation.png": 122,
	"./partners/zamani": 123,
	"./partners/zamani-cash": 124,
	"./partners/zamani-cash.png": 124,
	"./partners/zamani.jpeg": 123,
	"./pattern": 125,
	"./pattern.svg": 125,
	"./payment-1": 126,
	"./payment-1.png": 126,
	"./payment-2": 127,
	"./payment-2.png": 127,
	"./payment-3": 128,
	"./payment-3.png": 128,
	"./pcidss": 129,
	"./pcidss-white": 130,
	"./pcidss-white.png": 130,
	"./pcidss.png": 129,
	"./phone-bell": 131,
	"./phone-bell.jpg": 131,
	"./photolive": 132,
	"./photolive.png": 132,
	"./projet-lire": 133,
	"./projet-lire.png": 133,
	"./promotion-1": 134,
	"./promotion-1.png": 134,
	"./rafikicollet": 135,
	"./rafikicollet.svg": 135,
	"./receipt": 136,
	"./receipt.svg": 136,
	"./screenshot": 137,
	"./screenshot.png": 137,
	"./service-1": 138,
	"./service-1.png": 138,
	"./service-2": 139,
	"./service-2.png": 139,
	"./service-3": 140,
	"./service-3.png": 140,
	"./service-4": 141,
	"./service-4.png": 141,
	"./short-page": 142,
	"./short-page.png": 142,
	"./signatureOFF": 143,
	"./signatureOFF.jpg": 143,
	"./signin": 144,
	"./signin.png": 144,
	"./signup": 145,
	"./signup.png": 145,
	"./site1": 146,
	"./site1.png": 146,
	"./solution-cards": 147,
	"./solution-cards-dark": 148,
	"./solution-cards-dark.png": 148,
	"./solution-cards.png": 147,
	"./solution-link-qr": 149,
	"./solution-link-qr.png": 149,
	"./solution-ussd": 150,
	"./solution-ussd.png": 150,
	"./solution1": 151,
	"./solution1.svg": 151,
	"./solution2": 152,
	"./solution2.svg": 152,
	"./solution3": 153,
	"./solution3.svg": 153,
	"./spi": 154,
	"./spi.png": 154,
	"./success.json": 333,
	"./twiter": 155,
	"./twiter.png": 155,
	"./uncdf": 156,
	"./uncdf-2": 157,
	"./uncdf-2.png": 157,
	"./uncdf.png": 156,
	"./uncdfc": 158,
	"./uncdfc.png": 158,
	"./vectorsol1": 159,
	"./vectorsol1.png": 159,
	"./vectorsol3": 160,
	"./vectorsol3.png": 160,
	"./vectorsol4": 161,
	"./vectorsol4.png": 161,
	"./visa": 162,
	"./visa-2": 163,
	"./visa-2.png": 163,
	"./visa-square": 164,
	"./visa-square.png": 164,
	"./visa.png": 162,
	"./visa1": 165,
	"./visa1.png": 165,
	"./visa_logo": 166,
	"./visa_logo.png": 166,
	"./visa_logo.svg": 167,
	"./visa_logo.svg.png": 167,
	"./welcom-submit": 168,
	"./welcom-submit.png": 168,
	"./whatsapp": 16,
	"./whatsapp copy": 169,
	"./whatsapp copy.svg": 169,
	"./whatsapp.png": 16,
	"./whatsapp.svg": 334,
	"./woo1": 170,
	"./woo1.png": 170,
	"./woo2": 171,
	"./woo2.png": 171,
	"./woo3": 172,
	"./woo3.png": 172,
	"./woocommerce-white": 173,
	"./woocommerce-white.png": 173,
	"./zamani": 174,
	"./zamani-cash": 175,
	"./zamani-cash.png": 175,
	"./zamani.png": 174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 326;